<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px" scrollable :fullscreen="$vuetify.breakpoint.name == `xs`">
            <v-card :loading="loading" outlined>
                <v-card-title class="primary" dense>
                    <span class="headline text-uppercase white--text">{{ title }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container v-show="hasRole(['ADMIN', 'permission-role:save'])">
                        <v-subheader class="title">Perfis do Usuário</v-subheader>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-select
                                    v-model="product_id"
                                    :items="products"
                                    :rules="[required]"
                                    item-text="name"
                                    item-value="id"
                                    label="Produto"
                                    placeholder="Selecione o produto"
                                    readonly
                                    outlined
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                    <v-autocomplete
                                        v-model="permission.permission_id"
                                        :items="permissions_product"
                                        :rules="[required]"
                                        item-text="name"
                                        item-value="id"
                                        label="Permissão"
                                        placeholder="Selecione a permissão"
                                        outlined
                                    ></v-autocomplete>
                                </v-form>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="add"  :disabled="!hasRole([`ADMIN`, `permission-role:save`])" depressed>
                                <v-icon left>mdi-plus-circle-outline</v-icon>ADICIONAR
                            </v-btn>
                        </v-row>
                        <v-divider></v-divider>
                    </v-container>
                    <v-row>
                        <v-data-table
                            :headers="headers"
                            :items="items"
                            :loading="loading"
                        >
                            <template v-slot:item.product_name="{ item }">
                                {{ get_product_name_permission(item) }}
                            </template>
                            <template v-slot:item.permission_id="{ item }">
                                {{ get_permission_name(item) }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn class="ma-2" icon :disabled="item.loading  || !hasRole([`ADMIN`, `permission-role:delete`])" v-on="on" @click="remove(item)">
                                            <v-icon color="error">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span style="color:#FFF">Remover</span>
                                </v-tooltip>
                            </template>                
                        </v-data-table>
                    </v-row>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="close" outlined>
                        <v-icon left>mdi-close-circle-outline</v-icon>FECHAR
                    </v-btn>
                    <v-btn color="primary" @click="save" :disabled="!hasRole([`ADMIN`, `permission-role:save`])">
                        <v-icon left>mdi-content-save-outline</v-icon>SALVAR
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    import { required } from '@/utils/roles.js'
    export default {
        data: () => ({
            loading: null,
            valid: null,
            lazy: false,
            permission: {},
            headers: [
                { sortable: true, text: 'Produto', value: 'product_name' },
                { sortable: true, text: 'Permissão', value: 'permission_id' },
                { sortable: false, text: 'Ações', value: 'actions', align: 'center', width: '5%' }
            ],
            items: []
        }),
        computed: {
            ...mapState('product', ['products']),
            ...mapState('permission', ['permissions']),
            ...mapGetters('app', ['hasRole']),
            title() { return 'Permissões do Perfil: '+ this.role.name },
            dialog: {
                get() { return this.value },
                set(v) { this.$emit('input', v) }
            },
            permissions_product() {
                var context = this
                if (context.product_id) {
                    var permissions_filtred = []
                    
                    var permissions = context.permissions.filter(r => r.product_id == context.product_id)
                    permissions.forEach(r => {
                        if (context.items.filter(i => i.permission_id == r.id).length == 0) {
                            permissions_filtred.push(r)
                        }
                    });

                    return permissions_filtred
                }
                return []
            }
        },
        mounted() {
            this.search(this.role)
        },
        methods: {
            required,
            add() {
                if (this.$refs.form.validate()) {
                    this.items.push({ permission_id: this.permission.permission_id })
                }
            },
            remove({ permission_id }) {
                var index = false
                for (var i = 0; i < this.items.length; i++) {
                    if (index === false) {
                        if (this.items[i].permission_id == permission_id) {
                            index = i
                        }
                    }
                }
                this.items.splice(index, 1)
            },
            async save() {
                this.loading = true
                try {
                    await this.axios.post(this.$store.state.url_api + '/role/' + this.role.id +'/permissions', this.items)
                    this.close()
                }
                finally {
                    this.loading = false
                }
            },
            search({ id }) {
                if (!id) return ;
                var context = this
                context.loading = true
                this.axios.get(this.$store.state.url_api + '/role/' + id +'/permissions')
                    .then(r => context.items = r.data)
                    .finally(() => context.loading = false)
            },
            close() {
                this.dialog = false
                this.$refs.form.reset()
            },
            get_permission_name({ permission_id }) {
                if (permission_id) {
                    var permission = this.permissions.filter(r => r.id == permission_id)[0]
                    if (permission) {
                        return permission.name
                    }
                }
                return 'Perfil não encontrado'
            },
            get_product_name_permission({ permission_id }) {
                var permission = this.permissions.filter(r => r.id == permission_id)[0]
                if (permission) {
                    var product = this.products.filter(p => p.id == permission.product_id)[0]
                    if (product) {
                        return product.name
                    }
                }
                return 'Produto não encontrado'
            }
        },
        props: {
            value: Boolean,
            role: {
                type: Object,
                required: true
            },
            product_id: {
                type: String,
                required: true
            }
        },
        watch: {
            role(val) {
                this.search(val)
            }
        }
    }
</script>